import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useParams} from 'react-router-dom';

import {useNotificationSubscriptions} from '../hooks/useNotificationSubscriptions.ts';

export const ReloadRecordsButton = () => {
    const {id: productId} = useParams()

    if (!productId) {
        throw new Error('productId is required parameter')
    }
    const {fetchRecords} = useNotificationSubscriptions(productId);

    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
